<script setup lang="ts">
const {t} = useI18n();
const {page, fetchPage} = useContentPages();
const route = useRoute();
const config = useRuntimeConfig();

interface Props {
  slug: string,
}

const props = defineProps<Props>()

const { error } = await useAsyncData(
  `page-${props.slug}`,
  async () => {
    return new Promise(async (resolve, reject) => {
      try {
        await fetchPage(props.slug);
        // pageTitle.value = $seo.getTitle(`seo./pages.title`, {name: page.value.title});
        resolve();
      } catch (error) {
        reject({statusCode: error.statusCode, message: t(error.getMessage().message, error.getMessage().variables)});
      }
    });
  }
)

watchEffect(() => {
  if (error.value) {
    showError(error.value);
  }
})
</script>

<template>
  <section class="max-w-[1316px] mx-auto px-[10px] py-[60px] md:py-[119px]">
    <WidgetMecleeUiContent v-if="page && !error" :data="page" />
  </section>
</template>

<style scoped>

</style>